/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrganizationType {
    BANK = 'BANK',
    GOV = 'GOV',
    IO = 'IO',
    MFO = 'MFO',
    MOBILE_OPERATOR = 'MOBILE_OPERATOR',
    OPERATOR = 'OPERATOR',
    PAYM = 'PAYM',
    REG = 'REG',
    STATE_CREDIT_BUREAU = 'STATE_CREDIT_BUREAU',
    TELECOM_ANTIFRAUD = 'TELECOM_ANTIFRAUD'
}

